import React, { Component, Fragment } from 'react';

import { readCookie, writeCookie } from '../utils/cookies';
import CompareListings from './compare_listings';
import ControlBar from './control_bar';
import FilterPreferences from './filter_preferences';
import ListingTile from './listing_tile';
import NoResults from './no_results';
import moment from 'moment';

export default class ListingsCollection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      listings: this.props.listings,
      listingsFilter: null,
      listingsSort: null,
      priceFilter: 'unfurnished',
      compareListings: [],
    };
  }

  handleCompareClick = (listing) => {
    if (this.state && this.state.compareListings.includes(listing)) {
      for (var i = 0; i < this.state.compareListings.length; i++) {
        if (this.state.compareListings[i] === listing) {
          const stateClone = this.state.compareListings;
          stateClone.splice(i, 1);
          this.setState({
            compareListings: stateClone,
          });
        }
      }
    } else if (this.state && this.state.compareListings.length < 3) {
      this.setState({
        compareListings: [...this.state.compareListings, listing],
      });
    }
  };

  listingAddedToCompare = (listingId) => {
    const matches = this.state.compareListings.filter((listing) => listing.id === listingId);
    return matches.length > 0;
  };

  render() {
    return (
      <Fragment>
        <ControlBar sticky={this.props.stickyFilters}>
          <FilterPreferences
            initialCity={this.props.location}
            updateFilter={this.updateFilter}
            priceFilter={this.getPriceFilter()}
            onPriceFilterChange={this.priceFilterChanged}
            enableLocationFilter={this.props.enableLocationFilter}
            enableCompareFeature={this.props.enableCompareFeature}
          />
          <CompareListings
            enableCompareFeature={this.props.enableCompareFeature}
            compareListings={this.state.compareListings}
            showCount={true}
            hideOnMobile={true}
          />
        </ControlBar>
        {this.state.isLoading && <div>Loading...</div>}
        {<div className="homes">{this.renderListingTiles()}</div>}
        <CompareListings
          enableCompareFeature={this.props.enableCompareFeature}
          compareListings={this.state.compareListings}
          hideOnDesktop={true}
          showCount={true}
        />
      </Fragment>
    );
  }

  sortListings = (listingA, listingB) => {
    const listingAAvailableDate = moment(listingA.availableFrom);
    const listingBAvailableDate = moment(listingB.availableFrom);

    if (listingAAvailableDate === null && listingBAvailableDate === null) {
      return 0;
    }

    if (listingAAvailableDate === null) {
      return 1;
    }

    if (listingBAvailableDate === null || listingAAvailableDate.isBefore(listingBAvailableDate)) {
      return -1;
    }

    if (listingAAvailableDate.isSame(listingBAvailableDate, 'day')) {
      return 0;
    }

    return 1; // listingB is before listingA so move B up
  };

  renderListingTiles = () => {
    if (this.state.listings.length == 0) {
      return <NoResults />;
    }

    const listingsToShow = this.props.maxListingCount
      ? this.state.listings.slice(0, this.props.maxListingCount)
      : this.state.listings;
    return listingsToShow
      .sort(this.sortListings)
      .map((listing) => (
        <ListingTile
          key={listing.id}
          listing={listing}
          selectedPriceOption={this.getPriceFilter()}
          handleCompare={this.handleCompareClick}
          listingInCompare={this.listingAddedToCompare(listing.id)}
          enableCompareFeature={this.props.enableCompareFeature}
          propertyAvailableDate={listing.availableFrom}
          linkTarget={this.props.linkTarget}
        />
      ));
  };

  // This gets passed a function to run the listings through to determine
  // whether or not they should be shown. The function is created in the
  // FilterPreferences component currently and passed up.
  updateFilter = (f) => {
    this.setState(
      {
        isLoading: true,
        listingsFilter: f,
      },
      () => {
        this.applyFilterToListings();
      }
    );
  };

  applyFilterToListings = () => {
    const filteredListings = this.props.listings.filter((listing) => this.state.listingsFilter(listing));
    this.setState({
      listings: filteredListings,
      isLoading: false,
    });
  };

  getPriceFilter = () => {
    if (readCookie('price-preferences-furnishing')) {
      return readCookie('price-preferences-furnishing');
    } else {
      return this.state.priceFilter;
    }
  };

  priceFilterChanged = (priceFilter) => {
    writeCookie('price-preferences-furnishing', priceFilter);
  };
}
